import { Icon } from 'components/Icons';

import * as S from './BudgetStatus.styles';

type BudgetStatusProps = {
  status?: string;
};

/**
 * Status badge of a budget in the admin list: "Sent" once it has been sent
 * from the catalogue, "To send" otherwise. Reopening lives in the row menu.
 */
export function BudgetStatus({ status }: BudgetStatusProps): React.ReactElement {
  const isSent = status?.toLowerCase() === 'sent';

  return (
    <S.Badge $isSent={isSent}>
      {isSent ? <Icon name="FiLock" aria-hidden /> : undefined}
      {isSent ? 'Sent' : 'To send'}
    </S.Badge>
  );
}
